import { useEffect, useState } from 'react';
import { api } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

interface Student {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  grade: string;
}

interface Teacher {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  grade?: string;
  school?: string;
  schoolId?: string;
}

interface Schoolmates {
  [grade: string]: Student[];
}

const useStudentDashboard = (userId?: string) => {
  const [classmates, setClassmates] = useState<Student[]>([]);
  const [schoolmates, setSchoolmates] = useState<Schoolmates>({});
  const [teachers, setTeachers] = useState<Teacher[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { token } = useAuth();

  useEffect(() => {
    if (!userId || !token) return;
    setLoading(true);
    setError(null);
    api
      .get(`/students/dashboard?userId=${userId}`)
      .then((res) => {
        console.log("API RESPONSE", res.data);
        setClassmates(
          (res.data.data.classmates || []).filter((s: Student) => s._id !== userId)
        );
        setSchoolmates(res.data.data.schoolmates || {});
        setTeachers(res.data.data.teachers || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response?.data?.error || 'Error loading dashboard');
        setLoading(false);
      });
  }, [userId, token]);

  return { classmates, schoolmates, teachers, loading, error };
};

export default useStudentDashboard; 